import { AggOneDimDataItem } from '@patsnap/synapse_domain'
import { analysisOneDimTableBuilder } from './BAnalysisOneDimTable'

export const BAnalysisPieTable = analysisOneDimTableBuilder<AggOneDimDataItem>('BAnalysisPieTable')
